<template>
    <div>
        <div class="vx-row">
            <div class="vx-col w-full md:w-1/2 mb-base">
                <vx-card title="Left tree">
                    <div class="flex justify-between text-center">
                        <span>
                            <span class="treeInfoWrapper activeStatus">
                                <span>Next</span>
                                <p>
                                    <span v-if="tree.next_position === 1">-</span>
                                    <feather-icon v-if="tree.next_position === 0" icon="CircleIcon" :svgClasses="['fill-current h-4 w-4', 'text-primary']" />
                                </p>
                            </span>
                        </span>
                        <span class="treeInfoWrapper">
                            <span>Active / All</span>
                            <p class="text-5xl font-semibold">{{tree.left.active}} / {{tree.left.all}}</p>
                        </span>
                        <span class="treeInfoWrapper">
                            <span>Remaining</span>
                            <p class="text-4xl font-semibold">{{tree.remaining.left}}</p>
                        </span>
                    </div>
                </vx-card>
            </div>

            <div class="vx-col w-full md:w-1/2 mb-base">
                <vx-card title="Right tree">
                    <div class="flex justify-between text-center">
                        <span>
                            <span v-if="tree.next_position === 1" class="treeInfoWrapper activeStatus">
                                <span>Next</span>
                                <p>
                                    <span v-if="tree.next_position === 0">-</span>
                                    <feather-icon v-if="tree.next_position === 1" icon="CircleIcon" :svgClasses="['fill-current h-4 w-4', 'text-primary']" />
                                </p>
                            </span>
                        </span>
                        <span class="treeInfoWrapper">
                            <span>Active / All</span>
                            <p class="text-5xl font-semibold">{{tree.right.active}} / {{tree.right.all}}</p>
                        </span>
                        <span class="treeInfoWrapper">
                            <span>Remaining</span>
                            <p class="text-4xl font-semibold">{{tree.remaining.right}}</p>
                        </span>
                    </div>
                </vx-card>
            </div>
        </div>
        <div class="vx-row">
            <div class="vx-col w-full md:w-1/2 mb-base">
                <vx-card title="Disclaimer">
                    <span class="disclaimer"><strong>Next: </strong>Tree assigned to the next referral</span>
                    <span class="disclaimer"><strong>Active: </strong>Referrals in each tree</span>
                    <span class="disclaimer"><span>Remaining: </span>Referrals required in order to finish current cycle</span>
                </vx-card>
            </div>
            <div class="vx-col w-full md:w-1/2 mb-base">
                <vx-card title="Tree config">
                    <div class="vx-row">
                        <div class="w-1/2 text-center" style="display: flex; flex-direction: column;">
                            <p class="mb-3">Current config</p>
                            <span class="text-4xl"><span class="text-6xl mr-4">{{treeConfig[0]}}</span>:<span
                                    class="text-6xl ml-4">{{treeConfig[1]}}</span></span>
                            <div v-if="pendingConfig">
                                <p class="mb-3">Pending config</p>
                                <span class="text-3xl"><span class="text-4xl mr-4">{{pendingConfig.left_tree}}</span>:<span
                                        class="text-4xl ml-4">{{pendingConfig.right_tree}}</span></span>
                            </div>
                        </div>
                        <div class="w-1/2 text-center" style="display: flex; flex-direction: column;" v-if="allConfigOptions.length !== 0">
                            <p>Change config</p>
                            <ul class="configOptionsList">
                                <li v-for="config in allConfigOptions" v-bind:key="config.id">
                                    <vs-radio v-model="tmpConfigId" :vs-value="config.id">{{config.type}}</vs-radio>
                                </li>
                            </ul>
                            <div>
                                <vs-button class="w-1/2" v-on:click="changeConfig()">Change</vs-button>
                            </div>
                        </div>
                    </div>
                </vx-card>
            </div>
        </div>
    </div>
</template>

<script>

    import RestService from '../services/RestService';

    export default {
        name: "tree",
        async beforeMount() {

            // TODO handle errors

            const userBinaryResponse = await RestService.getUserBinary();
            if (userBinaryResponse.success) {
                this.tree = userBinaryResponse.data;
            }

            const treeConfigResponse = await RestService.getTreeConfig();
            // TODO optimize with data()
            if (treeConfigResponse.success) {
                this.treeConfig = [treeConfigResponse.data.active.left_tree, treeConfigResponse.data.active.right_tree];
                this.tmpConfigId = treeConfigResponse.data.active.id;
                this.currentConfigId = treeConfigResponse.data.active.id;
                this.pendingConfig = treeConfigResponse.data.pending;
            }

            const allConfigsResponse = await RestService.getAllConfigs();
            if (allConfigsResponse.success) {
                this.allConfigOptions = allConfigsResponse.data;
            }

        },
        data() {
            return {
                tree: {
                    left: 0,
                    right: 0,
                    next_position: -1,
                    remaining: {
                        left: 0,
                        right: 0
                    }
                },
                treeConfig: [0,0],
                allConfigOptions: [],
                currentConfigId: -1,
                tmpConfigId: -1,
                pendingConfig: null,
            }
        },
        methods: {
            async changeConfig() {
                if (this.tmpConfigId !== this.currentConfigId) {
                    const setConfigResponse = await RestService.changeConfig(this.tmpConfigId);
                    if (setConfigResponse.success) {
                        let newConfig = this.allConfigOptions.filter(c => c.id === this.tmpConfigId);
                        if (newConfig && newConfig.length === 1)
                            this.pendingConfig = newConfig[0];
                    }
                } else {
                    this.pendingConfig = null;
                }
            }
        }
    }
</script>

<style scoped>
    .treeInfoWrapper {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
    }
    .treeInfoWrapper.activeStatus {
        height: 100%;
    }

    .disclaimer {
        display: block;
        margin-bottom: 20px;
    }
    .disclaimer span {
        font-weight: bold;
    }

    .configOptionsList {
        display: flex;
        flex-wrap: wrap;
    }
    .configOptionsList li {
        width: 33%;
        padding: 20px;
    }
</style>